export default __webpack_public_path__ + "static/media/vip_shipping_mobile.6e0a5318.svg";